<template lang="pug">
  .component-card-smart-edit
    selectize-driver(
    @optionSelected="driverSelected"
    )
    button.button.expanded(v-on:click="edit") Save and Submit
</template>
<script type="text/babel">
  import SmartEdit from "components/structure/SmartEdit"
  import KeplerBackofficeSdk from 'src/lib/kepler/backoffice'
  import MaggieHelper from "src/maggieHelper";
  import SelectizeDriver from "../../structure/ui/lists/selectize/SelectizeDriver";

  export default {
    name: "CardSmartEdit",
    components: {SelectizeDriver, SmartEdit},
    data() {
      return {
        options: {
          translations: {},
          types: {
            enabled: [true, false],
          },
          disabled: [
            "id",
          ],
          list: [
            "id",
            "uid",
            "pin",
            "name",
            "chip_id",
            "enabled",
          ],
          listMode: 'blacklist',
        }
      }
    },
    created() {
    },
    methods: {
      driverSelected(driver) {
        this.item.driver = driver
        this.item.driver_id = driver.id
      },
      edit() {
        KeplerBackofficeSdk.cards.select(this.item.id).edit(this.item, (response) => {
          MaggieHelper.notification('edit-esit', 'Card bound successfully');
          location.reload()
        })
      }
    },
    props: [
      'item',
    ]
  }
</script>
<style lang="sass" rel="stylesheet/sass">

</style>



// WEBPACK FOOTER //
// CardBind.vue?185c97fb